import axios from 'axios';
import * as endpoints from './endpoints';

export function getCurrentVersion() {
  return axios.get(`${endpoints.CHANGE_LOG}/version`, endpoints.headers())
      .then((response) => {
        return response.data;
      });
}
